import React, { useState } from 'react';
import { BsChevronDoubleLeft, BsChevronDoubleRight } from 'react-icons/bs';
import { Flex, Icon, IconButton, Tooltip } from '@chakra-ui/react';
import PropTypes from 'prop-types';

import { analyticsIds } from '../../../constants/analyticsIds';
import { Nav, PageHeader } from '../../../styles/layoutDimensions';
import colors from '../../../styles/theme/foundation/colors';

const ToggleNavBox = ({ onClick = () => {}, isOpen }) => {
  const rightBorder = isOpen ? 'none' : `1px solid ${colors.greyScale['200']}`;
  const icon = isOpen ? BsChevronDoubleLeft : BsChevronDoubleRight;

  return (
    <Flex
      alignItems="center"
      borderRight={rightBorder}
      height={PageHeader.height}
      justify="center"
      width={Nav.collapsedWidth}
    >
      <Tooltip label={isOpen ? 'Collapse' : 'Expand'} placement="right">
        <IconButton
          aria-label="expanded nav"
          data-analytics-id={analyticsIds.header.toggleNavBarButton}
          dusk={analyticsIds.header.toggleNavBarButton}
          icon={<Icon as={icon} boxSize="24px" />}
          variant="textGrey"
          onClick={onClick}
        />
      </Tooltip>
    </Flex>
  );
};

ToggleNavBox.propTypes = {
  onClick: PropTypes.func,
  isOpen: PropTypes.bool
};

export default ToggleNavBox;
